import { Injectable } from '@angular/core';

import { Http, QueryHandlerFor, RootContext, Wrapper } from '@skylab-angular-shared/core';
import { SaleRegistryCollectionQuery, SaleRegistryCollectionQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SaleRegistryCollectionQuery)
@Wrapper(SaleRegistryCollectionQueryHandlerBase)
export class SaleRegistryCollectionQueryHandler {
    public constructor(
        http: Http,
        rootContext: RootContext
    ) { }
}
